export const TRACKING_PAGE_NAME = {
  forPageVisits: 'Search Page',
  forEventCardClicks: 'Search Page',
} as const;

export const SEARCH_QUERY_PARAM = 'q';
